
<template>
  <div>
    <van-nav-bar
      title="活动列表"
      fixed
      placeholder
      left-text="返回"
      left-arrow
      @click-left="goBack"
    />
    <div class="mt-2">
      <van-tabs type="card" color="#49cfd4">
        <van-tab title="当前活动">
          <div class="mt-2">
            <van-empty description="暂无活动" v-if="activeEvents.length==0"/>
            <div v-else
              class="
                p-1
                mx-1
                mt-0.5
                rounded-sm
                bg-white
                grid grid-rows-4 grid-flow-col
              "
              @click="goEventDetail(event.id)"
              v-for="(event,idx) in activeEvents"
              :key="idx"
            >
              <div class="justify-self-start">
                <span class="small-text text-gray">{{event.title}}</span>
              </div>

              <div class="justify-self-start">
                <span class="small-text text-gray-500">地点：{{event.place}}</span>
              </div>
              <div class="justify-self-start">
                <span class="small-text text-gray-500"
                  >时间：{{ event.beginTime.slice(5, 16)}}-{{event.endTime.slice(11,16) }}</span
                >
              </div>
              <div class="justify-self-start">
                <span class="small-text text-gray-500"
                  >报名截止：{{event.deadline.slice(5,16)}}</span
                >
              </div>
              <div class="row-span-4 justify-self-end">
                <van-image
                  width="80"
                  height="80"
                  src="https://img.yzcdn.cn/vant/cat.jpeg"
                />
              </div>
            </div>
          </div>
        </van-tab>
        <van-tab title="历史活动">
          <div class="mt-2">
            <van-empty description="暂无活动" v-if="pastEvents.length==0"/>
            <div v-else
              class="
                p-1
                mx-1
                mt-0.5
                rounded-sm
                bg-white
                grid grid-rows-4 grid-flow-col
              "
              @click="goEventDetail(event.id)"
              v-for="(event, idx) in pastEvents"
              :key="idx"
            >
              <div class="justify-self-start">
                <span class="small-text text-gray">{{event.title}}</span>
              </div>

              <div class="justify-self-start">
                <span class="small-text text-gray-500">地点：{{event.place}}</span>
              </div>
              <div class="justify-self-start">
                <span class="small-text text-gray-500"
                  >时间：{{ event.beginTime.slice(5, 16)}}-{{event.endTime.slice(11,16) }}</span
                >
              </div>
              <div class="justify-self-start">
                <span class="small-text text-gray-500"
                  >报名截止：{{event.deadline.slice(5,16)}}</span
                >
              </div>
              <div class="row-span-4 justify-self-end">
                <van-image
                  width="80"
                  height="80"
                  src="https://img.yzcdn.cn/vant/cat.jpeg"
                />
              </div>
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import { toRefs, reactive, onMounted } from "vue";
import { useRouter } from "vue-router";
import { getEvents } from "@/service/home";
export default {
  name: "events",
  components: {},
  setup() {
    const router = useRouter();
    const state = reactive({
      activeEvents: [],
      pastEvents:[]
    });
    onMounted(async () => {
      const { data:{list: events }} = await getEvents();
      state.activeEvents = events.filter(
        (event) => event.status == 2
      );
      state.pastEvents = events.filter(
        (event) => event.status == 3
      )
    });
    const goBack = () => router.go(-1);
    const goEventDetail = (id) => router.push({ name: "eventDetail", params: { id: id } });
    return {
      goBack,
      goEventDetail,
      ...toRefs(state),
    };
  },
};
</script>

<style lang="less" >
@import "../common/style/base";
.selected {
  background-color: #49cfd4;
  color: white;
}
.van-cell__title {
  flex: 1 1 auto;
}
.van-cell__value {
  flex: 1 1 auto;
}
</style>
